import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// Register PWA Service Worker — skip on external-facing Pro Forma pages
const isProFormaPage = window.location.pathname.startsWith("/p/");
if ("serviceWorker" in navigator && !isProFormaPage) {
  window.addEventListener("load", () => {
    navigator.serviceWorker
      .register("/sw.js")
      .then((reg) => {
        console.log("SW registered:", reg.scope);
        // Check for updates periodically
        setInterval(() => reg.update(), 60 * 60 * 1000);
      })
      .catch((err) => console.log("SW registration failed:", err));
  });
}

// Suppress PWA install prompt on Pro Forma pages (external-facing, shouldn't expose the app)
if (isProFormaPage) {
  window.addEventListener("beforeinstallprompt", (e) => {
    e.preventDefault();
  });
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
